import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { Empty } from '@vyaguta/vyaguta-ui';

import NoticeCard from './NoticeCard';

import { lilypad } from 'assets/images';
import { useUserInfoQuery, useUserNotices } from 'hooks/query/useUserInfo';
import type { Notice } from 'interface/notice';

export const NoticeBoard: React.FC = () => {
  const notices = useUserNotices() as Notice[];
  const { isLoading: isNoticesLoading } = useUserInfoQuery();

  return (
    <div className="notice-board__list custom-scroll-bar">
      <div className="mtpx-18">
        {isNoticesLoading ? (
          <SkeletonTheme baseColor="#ffffff33" highlightColor="#ffffff66">
            {Array(3)
              .fill(0)
              .map((item, index) => (
                <Skeleton key={index} className="notice-card-loader" />
              ))}
          </SkeletonTheme>
        ) : !notices.length ? (
          <Empty image={lilypad} className="notice-board__empty-list mtpx-18" message="There are no notices" />
        ) : (
          <>
            {notices.map((noticeItem, index) => (
              <NoticeCard notice={noticeItem} key={index} />
            ))}
          </>
        )}
      </div>
    </div>
  );
};
